// @flow

import React, {useContext, memo} from 'react';

import {getWidthOfText} from '@pb/kit-util-get-width-of-text';
import {LocaleContext} from '@pb/kit-context-locale';
import {INTEGER} from '@pb/kit-formatters';

import type {Node, ComponentType} from 'react';
import type {LocaleContextType} from '@pb/kit-context-locale';

const DEFAULT_STYLE = {fontSize: 12};

type Props = {|
    maxRowNumber: number,
    rowNumber?: number,
    pinned?: boolean,
    placeholder?: Node,
    mix?: string,
    style?: Object,
|};

export const RowNumber: ComponentType<Props> = memo<Props>(({
    rowNumber = 0, maxRowNumber, pinned, placeholder = null, mix = '', style
}) => {
    const {locale} = useContext<LocaleContextType>(LocaleContext);
    const width = getWidthOfText(INTEGER.format(maxRowNumber, locale), style || DEFAULT_STYLE);

    return (
        <span
            style={{width}}
            className={mix}>
            {pinned ? placeholder : INTEGER.format(rowNumber, locale)}
        </span>
    );
});

RowNumber.displayName = 'RowNumber';
